export const ENABLE_BUSINESS_PROFILE_HEADER = 'release-business-profile-header';
export const ENABLE_CS_SCHEDULE_UPDATE = 'enable-cs-schedule-update';
export const ENABLE_DASHBOARD_CAROUSEL = 'enable-dashboard-carousel';
export const ENABLE_EDUCATION_WIDGET = 'enable-education-widget';
export const ENABLE_EIN_UPDATE = 'enable-ein-update';
export const ENABLE_FREEDASH_ROUTING = 'enable-freedash-routing';
export const ENABLE_HOLIDAY_BANNER = 'enable-holiday-banner';
export const ENABLE_MEETING_MINUTES_JOURNEY = 'enable-meeting-minutes-journey';
export const ENABLE_NEW_ZD_BILLING_PAGE = 'enable-new-zd-billing-page';
export const ENABLE_ORDER_HISTORY_V2 = 'enable-order-history-v2';
export const ENABLE_SHOW_PREVIOUS_YEAR_TAX_FILING_PLAN = 'enable-show-previous-year-tax-filing-plan';
export const ENABLE_ZERO_STAGE_TAX_SERVICES_PAGE = 'enable-zero-stage-tax-services-page';
export const ENABLE_SIMPLE_ORDER_TRACKER = 'enable-order-tracker-dashboard';
export const RELEASE_BENEFICIAL_OWNERSHIP_PAGE = 'release-beneficial-ownership-page';
export const RELEASE_CONSTANT_CONTACT_PRODUCT_CARD = 'release-constant-contact-product-card';
export const RELEASE_GOOGLE_BUSINESS_PROFILE_PHASE_2 = 'release-google-business-profile-phase-2';
export const RELEASE_OCOYA_PRODUCT = 'release-social-media-marketing-zb';
export const RELEASE_STANDALONE_INVOICING = 'release-standalone-invoicing';
export const RELEASE_WEB_TOOLS_SINGLE_LEFT_NAV_MENU_ITEM = 'release-web-tools-single-left-nav-menu-item';
export const RELEASE_ZB_CHASE_PRODUCT = 'release-zb-chase-product';
export const SHOW_DOWNLOAD_RECEIPTS = 'show-download-receipts';
export const SIMPLIFY_ONBOARDING_DOMAIN_DASHBOARD_SWITCH = 'simplify-onboarding-domain-dashboard-switch';
export const RELEASE_TRADEMARKS = 'release-trademarks';
export const RELEASE_UNIVERSAL_CHECKOUT = 'release-universal-checkout';
export const ENABLE_STANDALONE_PRODUCT_PAGE = 'enable-standalone-product-page-migration';
